import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogIn } from "lucide-react";

export default function LoginPage() {
  const { user, adminLogin } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (user && user.role === "admin") {
    return <Navigate to="/admin" replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    const res = await adminLogin(email, password);
    setSubmitting(false);
    if (res.ok) {
      navigate("/admin");
    } else {
      setError(res.error || "Login failed");
    }
  };

  return (
    <div data-testid="login-page" className="min-h-[70vh] flex items-center justify-center px-4">
      <form
        onSubmit={submit}
        className="w-full max-w-md bg-slate-900 border border-slate-800 rounded-2xl p-8"
      >
        <div className="inline-flex items-center justify-center w-12 h-12 rounded-lg bg-yellow-400 text-slate-950 mb-4">
          <LogIn className="w-6 h-6" />
        </div>
        <h1 className="font-[Outfit] text-3xl font-black tracking-tight">Staff login</h1>
        <p className="text-sm text-slate-400 mt-1">Admins only.</p>

        <div className="mt-8 space-y-4">
          <label className="block">
            <span className="text-xs font-mono uppercase tracking-wider text-slate-500 mb-1.5 block">Email</span>
            <input
              data-testid="login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-slate-950 border border-slate-800 rounded-md px-3 py-2.5 text-sm text-white focus:outline-none focus:border-yellow-400"
            />
          </label>
          <label className="block">
            <span className="text-xs font-mono uppercase tracking-wider text-slate-500 mb-1.5 block">Password</span>
            <input
              data-testid="login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-slate-950 border border-slate-800 rounded-md px-3 py-2.5 text-sm text-white focus:outline-none focus:border-yellow-400"
            />
          </label>
        </div>

        {error && (
          <div data-testid="login-error" className="mt-4 text-red-400 bg-red-500/10 border border-red-500/30 px-3 py-2 rounded text-sm">
            {error}
          </div>
        )}

        <button
          data-testid="login-submit"
          type="submit"
          disabled={submitting}
          className="mt-6 w-full bg-yellow-400 text-slate-950 font-bold px-4 py-3 rounded-md uppercase tracking-wide hover:bg-yellow-300 disabled:opacity-50"
        >
          {submitting ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
